import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { accessControlList } from "../../services/accessControlService";

const initialState = {
  permissions: null,
  loading: true,
  error: null,
};

// Thunk for fetching permissions
export const getPermissions = createAsyncThunk(
  "permission/getPermissions",
  async ({ authId }, { rejectWithValue }) => {
    try {
      if (authId) {
        const res = await accessControlList({ userId: authId });
        return res?.data?.permission || [];
      } else {
        return [];
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermission: (state, action) => {
      state.permissions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
      })
      .addCase(getPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch permissions";
      });
  },
});

export const { setPermission } = permissionSlice.actions;
export default permissionSlice.reducer;
